import { IYuzBbox } from '../interfaces/yuz.interfaces';

/**
 * Bbox formatını otomatik algılar ve normalize eder.
 * AI formatı: w,h = sağ-alt köşe koordinatları (x < w, y < h)
 * Kart formatı: w,h = genişlik, yükseklik
 * Döndürülen değerler: 0-1 arası normalize edilmiş (x, y, genişlik, yükseklik)
 */
export function normalizeBbox(bbox: IYuzBbox): { x: number; y: number; w: number; h: number } {
  let x = bbox.x / 100;
  let y = bbox.y / 100;
  let w: number;
  let h: number;

  // AI formatı kontrolü: w ve h, sağ-alt köşe ise
  if (bbox.w > bbox.x + 5 && bbox.h > bbox.y + 5) {
    w = (bbox.w / 100) - x;
    h = (bbox.h / 100) - y;
  } else {
    w = bbox.w / 100;
    h = bbox.h / 100;
  }

  if (w <= 0 || h <= 0) {
    w = bbox.w / 100;
    h = bbox.h / 100;
  }

  return { x, y, w, h };
}

/**
 * CSS background-image ile yüz kırpması için stil hesaplar.
 * YuzCropComponent ve YuzAvatarComponent'te tekrar eden mantığı merkezileştirir.
 */
export function bboxCropStili(resimUrl: string, bbox: IYuzBbox, boyutPx: number, yuvarlak = true): string {
  const { x, y, w, h } = normalizeBbox(bbox);
  if (w <= 0 || h <= 0) return `width:${boyutPx}px;height:${boyutPx}px;background:#333;`;

  const bgSizeX = (1 / w) * 100;
  const bgSizeY = (1 / h) * 100;
  const bgPosX = w >= 1 ? 50 : (x / (1 - w)) * 100;
  const bgPosY = h >= 1 ? 50 : (y / (1 - h)) * 100;
  const borderRadius = yuvarlak ? '50%' : '4px';

  return `width:${boyutPx}px;height:${boyutPx}px;` +
    `background-image:url('${resimUrl}');` +
    `background-size:${bgSizeX}% ${bgSizeY}%;` +
    `background-position:${bgPosX}% ${bgPosY}%;` +
    `border-radius:${borderRadius};`;
}
